<template>
  <div class="rule" :class="cssType">
    <div class="rule-title" :class="locale"></div>
    <div class="rule-content">
      <div class="rule-item">{{ $t('poolParty.rule.item1') }}</div>
      <div class="rule-item">{{ $t('poolParty.rule.item2') }}</div>
      <div class="rule-item">{{ $t('poolParty.rule.item3') }}</div>
      <div class="rule-item">{{ $t('poolParty.rule.item4') }}</div>
      <div class="rule-item">{{ $t('poolParty.rule.item5') }}</div>
      <div class="rule-item">{{ $t('poolParty.rule.item6') }}</div>
    </div>
  </div>
</template>

<script setup>
import { isMobile } from '@/utils'
import { useI18n } from 'vue-i18n'
const { locale } = useI18n()
const cssType = isMobile ? 'mobile' : 'pc'
</script>

<style scoped lang='less' src='./pc_style.less'></style>
<style scoped lang='less' src='./mobile_style.less'></style>